import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { height: 8, viewBox: "0 0 12 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1.5L6 6.5L11 1.5", stroke: "current", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowDown);
export default ForwardRef;
